// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3-Wv_","content":"GlobalSearch_content__1m-QK"};